export var setValueInSessionStorage = function setValueInSessionStorage(key, value) {
  window.sessionStorage.setItem(key, value);
};
export var removeValueFromSessionStorage = function removeValueFromSessionStorage(key) {
  return window.sessionStorage.removeItem(key);
};
export var getValueFromSessionStorage = function getValueFromSessionStorage(key) {
  return window.sessionStorage.getItem(key);
};
export var getAllKeysInSessionStorage = function getAllKeysInSessionStorage() {
  var keys = [];

  for (var i = 0; i < window.sessionStorage.length; i += 1) {
    keys.push(window.sessionStorage.key(i));
  }

  return keys;
};
export var clearSessionStorage = function clearSessionStorage() {
  window.sessionStorage.clear();
};